<template>
  <b-card
    class=""
    no-body
  >
    <div class="d-flex justify-content-between">
      <div
        class="product-list__tabs overflow-auto"
        style="flex: 1"
      >
        <div
          v-for="(item, index) in listMenu"
          :key="`list-item-${index}`"
          class="tab-item text-nowrap"
          :class="{ 'active' : active === index + 1, 'compact': compact }"
          @click="switchTab(index, item)"
        >
          {{ item.title }} <strong v-if="item.counter && item.counter !== '0'">({{ item.counter }})</strong>
        </div>
      </div>

      <div style="flex: none">
        <slot name="action"></slot>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    menu: {
      type: Array,
      required: true,
    },
    active: {
      type: Number,
      default: 0,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listMenu() {
      return this.menu.filter(el => el.access === true || el.access === null)
    },
  },
  methods: {
    switchTab(indexActive, data) {
      const otherQuery = data.otherQuery ? data.otherQuery : {}
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: indexActive + 1,
          page: 1,
          keyword: undefined,
          ...otherQuery,
        },
      })

      if (data.action) {
        this.$store.dispatch(data.action, {
          ...this.$route.query,
          ...data.payload,
          page: 1,
          keyword: undefined,
          ...otherQuery,
        })
      }

      if (data.otherAction) {
        data.otherAction(indexActive + 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #7367f0;

.product-info {
  display: flex;
  &__image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
  }
}

.product-list {
  &__tabs {
    display: flex;
  }
  &__filters {
    padding: 16px 20px;
    font-size: 14px !important;
  }
  &__footer {
    padding: 16px 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.tab-item {
  padding: 12px 28px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #bdbdbd;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
  &.active {
    color: $primary;
    border-color: $primary;
  }
  &.compact {
    padding: 10px 16px;
    font-size: 14px;
  }
}
</style>
